import { insightsApiInstance } from "@/shared/api/axios";

export const getStoreImageSrc = (imageId: string) => {
  const baseURL = insightsApiInstance.defaults.baseURL;
  return `${baseURL}/store_images/${imageId}`;
};
